import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = ({ fill, ...props }) => {
  return (
    <Svg width="27" height="7" viewBox="0 0 27 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="3.39117" cy="3.39117" r="3.39117" fill={fill || '#006DFE'} />
      <circle cx="13.1724" cy="3.39117" r="3.39117" fill={fill || '#006DFE'} />
      <circle cx="22.9576" cy="3.39117" r="3.39117" fill={fill || '#006DFE'} />
    </Svg>
  )
}

export default Icon
